module.exports = __webpack_public_path__ + "img/check.fcbe3137.svg";